import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import {darkBlack} from 'material-ui/styles/colors';
import ButtonLoaderWithText from 'components/loaders/ButtonLoaderWithText';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {Row, Col} from 'react-flexbox-grid/lib';
import {sendEventClassificationUpdate} from 'actions/icnActions';
import * as settings from 'settings/settings';
import $ from 'jquery';

class EventClassification extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            selectedEventClassification: props.icn.eventClassification
        };

        this.handleEventClassificationChange = this.handleEventClassificationChange.bind(this);
        this.selectFieldMenuItem = this.selectFieldMenuItem.bind(this);
        this.handleUpdateClick = this.handleUpdateClick.bind(this);
    }

    selectFieldMenuItem(translate, selectedId, list) {
        return list.map(item => (
          <MenuItem
            key={item.id}
            insetChildren={true}
            checked={selectedId && selectedId === item.value}
            value={item.value}
            primaryText={translate(item.localizationKey)}
          />
        ));
    }

    /**
     * per gestire il selectedValue del SelectItem
     * @param {} event
     * @param {*} index
     * @param {*} response
     */
    handleEventClassificationChange(name, value) {
        var { selectedEventClassification } = this.state;

        selectedEventClassification = value;

        console.info("EventClassification changed in " + value);

        this.setState({ selectedEventClassification });
    }

    handleUpdateClick(){
        this.props.sendEventClassificationUpdate(this.props.icn.id, this.state.selectedEventClassification);
    }

    render() {
        console.info("EventClassification rendered");

        var { translate, icn, eventClassificationList, isUpdating, currentUserName } = this.props;
        var canEdit = false;

        if(settings.EventClassificationUsers)
        {
            $.each(settings.EventClassificationUsers, function (index, item){

                if(item === currentUserName)
                {
                    canEdit = true;
                    return;
                }

            });
        }

        return (
            <div style={{margin: 0, padding: 10}}>
                {
                    canEdit ?
                    <Row>
                        <Col md={3}>
                            <span style={{color: darkBlack}}>
                                {translate('GLOBAL.eventClassification')}:&nbsp;&nbsp;
                            </span>
                        </Col>

                        <Col md={4} style={{position: 'relative', top: -10}} >
                            <SelectField
                                value={this.state.selectedEventClassification}
                                onChange={(event, index, value) => {this.handleEventClassificationChange("selectedEventClassification", value)}}
                                name="selectedEventClassification"
                                fullWidth={false}>
                                {this.selectFieldMenuItem(translate, this.state.selectedEventClassification, eventClassificationList)}
                            </SelectField>

                        </Col>
                        <Col md={3} style={{position: 'relative', top: -7}} >
                        {
                            isUpdating? <ButtonLoaderWithText />
                            :
                            <FlatButton label="Update" primary={true} onClick={this.handleUpdateClick} />
                        }

                        </Col>
                    </Row>
                    :
                    <div>
                    <span style={{color: darkBlack}}>
                        {translate('GLOBAL.eventClassification')}:&nbsp;&nbsp;
                    </span>
                        {icn.eventClassification}
                    </div>
                }

            </div>
        );
    }
}

EventClassification.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        icn: state.icnSearch.item,
        eventClassificationList: state.appData.eventClassificationListForDropDown,
        isUpdating: state.eventClassification.isUpdating,
        currentUserName: state.user.currentUser.username
    }
}
export default connect(mapStateToProps, {sendEventClassificationUpdate})(EventClassification);


// WEBPACK FOOTER //
// ./src/containers/eventClassification/EventClassification.js